import {
  ChangeDetectorRef,
  ComponentFactoryResolver,
  Directive,
  Input,
  Type,
  ViewContainerRef
} from "@angular/core";
import { ICol } from "../models/columns/i-col";
import { ICellComponent } from "../models/i-cell-component";

@Directive({
  selector: "[cellHost]",
  inputs: ["componentData"],
})
export class CellHostDirective<
  T extends object,
  C extends Type<ICellComponent<T>>
> {
  @Input() colConfig!: ICol<T, C>;

  @Input() set componentData(data: T) {
    if (!data) return;
    this.appendComponentInstance(this.colConfig.component, data);
  }

  constructor(
    public viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef
  ) {}

  appendComponentInstance(
    component: Type<ICellComponent<T>>,
    data: T
  ): ICellComponent<T> {
    //if (!this.colConfig.component) return;
    const myFactory =
      this.componentFactoryResolver.resolveComponentFactory<ICellComponent<T>>(
        component
      );
    const componentRef = this.viewContainerRef.createComponent(myFactory);
    componentRef.instance.setComponentData(data, this.colConfig);
    //this.colConfig.setComponentData(componentRef.instance, data);
    //this.cdr.detectChanges();
    return componentRef.instance;
  }
}
